// extracted by mini-css-extract-plugin
export default {"spin":"styles_spin__o9gdX"};